import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from '../../../api/useFetch';
import Loader from '../../../components/special/Loader';
import Pagination from '../../../components/special/Pagination';
import ExoDialog from '../../../components/exo/ExoDialog';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ProjectAddElementButton } from '../../../components/exo/project/ProjectAddElementButton';
import { updateOrCreate } from '../../../components/special/updateOrCreate';
import { API_DELETE, DBRequest, useConfig } from '../../../api/api';
import NewTravelExpensePreset from '../NewTravelExpensePreset';
import { TravelExpensePresetCard } from './TravelExpensePresetCard';
import TravelExpenseExportDialog from './TravelExpenseExportDialog';

export const TravelExpensePresetsTab = ({ project }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const { apiData, setApiData } = useFetch(
    `travel-expense-presets?projectId[eq]=${project.id}`
  );

  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);
  const [exportOpen, setExportOpen] = useState(false);

  function handleSave(preset) {
    handleCloseForm();
    setApiData(updateOrCreate(apiData, preset));
  }

  function handleCloseForm() {
    setOpen(false);
    setEdit(null);
  }

  function handleDelete(preset) {
    DBRequest({
      config,
      path: `travel-expense-presets/${preset.id}`,
      method: API_DELETE(),
      onLoading: setIsLoading,
      onResponse: () =>
        setApiData((prev) => ({
          ...prev,
          data: prev.data.filter((p) => p.id !== preset.id),
        })),
    });
  }

  return (
    <Box className="flex flex-col justify-between gap-2 overflow-hidden w-full relative">
      <Loader active={isLoading || !apiData} />
      <Box className="flex flex-col gap-2 h-full overflow-y-auto w-full">
        <Box className="flex items-center justify-between gap-2">
          <Typography className="opacity-50 max-w-[600px]">
            {t(
              'Save recurring trips for this project so employees can quickly request travel expenses without re-entering the details.'
            )}
          </Typography>
          <Tooltip title={t('CSV exportieren')}>
            <IconButton onClick={() => setExportOpen(true)}>
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>
        </Box>
        {apiData?.data.map((preset) => (
          <TravelExpensePresetCard
            key={preset.id}
            preset={preset}
            project={project}
            onEdit={(p) => setEdit(p)}
            onDelete={handleDelete}
          />
        ))}
        <ProjectAddElementButton
          label={t('New Destination')}
          addLabel={t('New Destination')}
          onClick={() => setOpen(true)}
          size="small"
          className="backdrop-blur-lg"
        />
      </Box>
      <Pagination
        data={apiData}
        setData={setApiData}
        setLoading={setIsLoading}
      />
      <ExoDialog open={open || Boolean(edit)} onClose={handleCloseForm} limitWidth>
        <NewTravelExpensePreset
          projectId={project.id}
          startData={edit}
          onCreate={handleSave}
          onClose={handleCloseForm}
        />
      </ExoDialog>
      <TravelExpenseExportDialog
        open={exportOpen}
        onClose={() => setExportOpen(false)}
        project={project}
      />
    </Box>
  );
};

export default TravelExpensePresetsTab;
